export default "__VITE_ASSET__Cz0s2PrX__"